import axios from "axios";

const axiosInstance = axios.create({
    baseURL : 'https://api.yourtravelshop.travel',
});

// Intercepteur pour ajouter le token dans les en-têtes des requêtes sortantes
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercepteur pour gérer les erreurs de réponse
axiosInstance.interceptors.response.use(
    (response) => response, // Retourne la réponse si elle est réussie
    (error) => {
        if (error.response && error.response.status === 401) {
            // Si l'erreur est une 401 (token invalide ou expiré)
            localStorage.removeItem("token"); // Supprime le token expiré ou invalide
            window.location.href = "/Login"; // Redirige vers la page de connexion
        }
        return Promise.reject(error); // Si ce n'est pas une erreur 401, on laisse passer l'erreur
    }
);

export default axiosInstance;
